<div
  class="lds-dual-ring"
  role="status"
  [attr.aria-label]="'Cargando contenido'"
  [attr.aria-live]="'polite'"
></div>
